import { useEffect, useState } from 'react';

import { breakpointsNumbers } from 'styles/cp';

// NOTE: Pass the breakpoint threshold (in px). Defaults to md
export function useIsMobileScreen(thresholdPx: number = breakpointsNumbers.md) {
  // On server, we cannot know width; default to mobile false to avoid SSR/CSR mismatch
  const [isMobile, setIsMobile] = useState<boolean>(false);

  useEffect(() => {
    // Guard for non-browser environments
    if (typeof window === 'undefined') {
      return;
    }

    // Prefer matchMedia for accurate breakpoint checks
    const mediaQuery = window.matchMedia(`(max-width: ${thresholdPx}px)`);
    const update = () => setIsMobile(mediaQuery.matches);

    // Initialize and subscribe
    update();
    if (typeof mediaQuery.addEventListener === 'function') {
      mediaQuery.addEventListener('change', update);
      return () => mediaQuery.removeEventListener('change', update);
    } else {
      // Fallback for older browsers
      const onResize = () => setIsMobile(window.innerWidth <= thresholdPx);
      window.addEventListener('resize', onResize);
      return () => window.removeEventListener('resize', onResize);
    }
  }, [thresholdPx]);

  return isMobile;
}
